module.exports = __webpack_public_path__ + "img/share-download-img.182a920d.jpg";